import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

const blockFieldFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		await state.wrapContainer(
			formatter.openTag("block-field", { bind: node.attrs.bind, placeholder: node.attrs.placeholder }),
			formatter.closeTag("block-field"),
			node,
			async () => await state.renderContent(node),
			formatter.indentsContainers,
		);
	};

export default blockFieldFormatter;
